import React, { ReactElement } from 'react';
import { Alert } from '../../../../../../../components/CiscoUi';

export type ConfigurationEditTopologyWarningProps = {
  warning: TopologyWarning;
};

export const ConfigurationEditTopologyWarning = ({
  warning: { message, detail },
}: ConfigurationEditTopologyWarningProps): ReactElement => (
  <Alert showIcon colour="warning">
    {`${message} (${detail})`}
  </Alert>
);
